import React, { useState, useEffect } from 'react';
import './popAnexos.css';
import api from '../../../apiClient';
import ListaAnexosSolicitante from '../../ListaAnexos/listaAnexos';

const AnexoSolicitante = ({ numeroSati, isOpen, onClose, children }) => {

    const [base64, setBase64] = useState("");
    const [fileName, setFileName] = useState("");

    const [anexos, setAnexos] = useState([]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        setFileName(file.name);

        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                setBase64(reader.result);
            };

            reader.onerror = (error) => {
                console.error("Erro ao converter o arquivo para Base64: ", error);
            };
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        let satNum = numeroSati;
        let Arquivo64 = base64;
        let nomArq = fileName;

        if (!nomArq?.trim() || !Arquivo64) {
            alert('Por favor, selecione um arquivo para anexar.');
            return;
        }
        try {
            const response = await api.post('/api/inserirAnexo', {
                satNum, nomArq, Arquivo64
            });
            alert(response.data?.message || 'Anexo salvo.');
            setFileName('');
            setBase64('');
            buscandoAnexos();
        } catch (error) {
            console.error('Erro ao inserir dados:', error);
            const msg = error.response?.data?.message || error.response?.data?.error || 'Erro ao gravar anexo. Tente novamente.';
            alert(msg);
        }
    };

    const buscandoAnexos = async () => {

        let listaAnexos = [];
        let satNum = numeroSati;

        try {
            const response = await api.post('/api/satAnexos', { satNum });

            let i = 0;

            while (i < response.data.length) {
                const item = response.data[i];
                listaAnexos.push({
                    satNum: item.SATNUM ?? item.satNum,
                    seqAne: item.SEQANE ?? item.seqAne,
                    seqHis: item.SEQHIS ?? item.seqHis,
                    nomArq: item.NOMARQ ?? item.nomArq,
                    arquivo: item.ARQUIVO ?? item.arquivo ?? item.Arquivo64
                });
                i++;
            }


        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setAnexos(listaAnexos);
    }

    useEffect(() => {
        if (isOpen && numeroSati) buscandoAnexos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, numeroSati]);


    if (!isOpen) return null;

    return (
        <div className="modal-overlay btn-secondary ">
            <div className="modal-content">
                <h2>Adicionar Anexo - {numeroSati}</h2>

                <div className="input-group mb-3">
                    <input type="file" onChange={handleFileChange} className="form-control" id="inputGroupFile02" />
                    <button onClick={handleSubmit} className="btn btn-outline-secondary" type="button" id="inputGroupFileAddon03">Salvar</button>
                    <button onClick={buscandoAnexos} className="ms-auto btn btn-outline-secondary" type="button"><i className="fa fa-refresh" aria-hidden="true" /></button>
                </div>

                <button className="close-button" onClick={onClose}>Fechar</button>
                <p></p>
                <ListaAnexosSolicitante arrayAnexos={anexos} satNum={numeroSati} baseUrlDownload={null} />
                {children}
            </div>
        </div >
    );
};

export default AnexoSolicitante;